import { ContributorProfile } from "./ContributorProfile";
import { DonationImpactCards } from "./DonationImpactCards";
import { DonationsHistory } from "./DonationsHistory";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ContributionHistory(_ref) {
  let {
    contributionsData,
    address,
    ensName
  } = _ref;
  const totals = contributionsData === null || contributionsData === void 0 ? void 0 : contributionsData.totals;
  return /*#__PURE__*/_jsx("main", {
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col gap-6",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex flex-col gap-2",
        children: [/*#__PURE__*/_jsx(ContributorProfile, {
          address: address,
          ensName: ensName
        }), /*#__PURE__*/_jsx("div", {
          className: "text-sm text-gray-500",
          children: "Please note that your recent transactions may take a short while to reflect in your donation history, as processing times may vary."
        })]
      }), /*#__PURE__*/_jsx(DonationImpactCards, {
        totals: totals
      }), /*#__PURE__*/_jsx("div", {
        className: "text-2xl",
        children: "Donation History"
      }), /*#__PURE__*/_jsx(DonationsHistory, {
        contributionsData: contributionsData
      })]
    })
  });
}